import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { useAppManager } from 'core/hooks';
import { useRouterStore } from 'apps/hooks';

import { clientStore } from 'apps/client/app';
import { Button, OrSeparator } from 'components';
import { SignUpAppManager } from 'apps/profile/signUp/appManager';
import { TextField } from 'libs/forms/views/fieldTypes/text';
import { SocialButtons } from 'apps/signIn/views/socialButtons';
import { PasswordField } from 'libs/forms/views/fieldTypes/password';
import { Label } from 'libs/forms/styles';
// import { FormWrapper } from 'libs/forms/styles';

import {
  CompactSignUpWrapper,
  SignUpButtonWrapper,
  FormWrapper,
} from './compactSignUp.styled';

const CompactSignUp = ({ isModal }) => {
  const routerStore = useRouterStore();
  const { params } = routerStore.route;
  const { username, email, password } = params;

  const appManager = useAppManager(SignUpAppManager, null, {
    params: routerStore.params,
    isModal,
  });
  if (username) {
    appManager.signUpApp.user.username = username;
  }
  if (email) {
    appManager.signUpApp.user.email = email;
  }
  if (password) {
    appManager.signUpApp.user.password = password;
    clientStore.routerStore.params.set('password', '');
  }
  if (username && email && password && !isModal) {
    appManager.signUpApp.wizard.Next();
  }

  const form = appManager.signUpApp.wizard.activeForm;

  return (
    <CompactSignUpWrapper>
      <h1 style={{ color: 'black' }}>Almost there!</h1>
      <p>
        Sign-up for free and your quote will be immediately submitted to our
        team.
      </p>
      <SocialButtons />
      <OrSeparator />
      <FormWrapper
        onSubmit={e => {
          e.preventDefault();
          appManager.signUpApp.CreateProfile();
        }}
      >
        <div>
          <Label bold>Email</Label>
          <TextField fieldStore={form.fieldStores.get('email')} />
        </div>
        <div>
          <Label bold>Username</Label>
          <TextField fieldStore={form.fieldStores.get('username')} />
        </div>
        <div>
          <Label bold>Password</Label>
          <PasswordField fieldStore={form.fieldStores.get('password')} />
          <span style={{ fontSize: '12px' }}>
            By signing up, you accept our{' '}
            <a href='/terms' target='_blank'>
              Terms & Conditions
            </a>{' '}
            and{' '}
            <a href='/privacy' target='_blank'>
              Privacy Policy
            </a>
            . Protected by reCAPTCHA.
          </span>
        </div>
        <SignUpButtonWrapper>
          <Button
            text='Sign up now'
            icon='arrow_right'
            iconPosition='right'
            type='submit'
          />
        </SignUpButtonWrapper>
      </FormWrapper>
    </CompactSignUpWrapper>
  );
};

CompactSignUp.propTypes = {
  isModal: PropTypes.bool,
};

export default observer(CompactSignUp);
